import { createStyles, Select, TextInput, Radio, Button, Container, Stack, Text, Card, Grid, NumberInput,  Group, MultiSelect, Checkbox, Center, Table, Paper, Title } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import 'dayjs/locale/fr-ca';
import { useForm } from '@mantine/form';
import { createOneMember } from '../connections/requests';
import { useState } from 'react';
import InputMask from 'react-input-mask';
import actions from "./components/actions.json"
import {  IconX } from '@tabler/icons-react';
const useStyles = createStyles((theme) => ({
    root: {
        position: 'relative',
    },

    input: {
        height: 'auto',
        paddingTop: 18,
    },

    label: {
        position: 'absolute',
        pointerEvents: 'none',
        fontSize: theme.fontSizes.xs,
        paddingLeft: theme.spacing.sm,
        paddingTop: theme.spacing.sm / 2,
        zIndex: 1,
    },
}));
function formatPhone(phone){
    if(phone==="") return "";
    return phone.match(/\d+/g).join("")
}

export function AddMemberForm() {
    let today = new Date(Date.now());
    const { classes } = useStyles();
    const [birthdayMode,setBirthdayMode] = useState(false);
    const [languageAdd, setLanguage] = useState([
        { value: 'Francais', label: 'Francais' },
        { value: 'Anglais', label: 'Anglais' },
        { value: 'Espagnol', label: 'Espagnol' },
        { value: 'Creole', label: 'Creole' },
        { value: 'Arabe', label: 'Arabe' },
      ]);

    const form = useForm(
        { initialValues: 
        { idMembre:"",
            iuc:"",
            gsi:"",
            prenom: "",
             nom: "",
              email: "",
               phone: "",
               actif: true, genre: '', 
               dateOfBirth: "",
               countryOfOrigins:"",
               principalLanguages:"",
               languages:"",
               ageAnonym :false,
               dayOfBirth:"",
               monthOfBirth:"",
                civic: "",
                city:"", 
                postal: "",
                dateOfRegistration: today,
                dateOfMembership:today, type: ""
                ,volunteer:false,
                spouse:"",
                worker:"",
                immigrationStatus:"",
                dateOfImmigrationStatus:new Date(),
                dateOfArrivalCountry:new Date(),
                dateOfArrivalRegion:new Date(),
                education:{diplomas:'',fieldOfStudy:""},actions:{"0":false},children:[{firstName:"",lastName:""}] },
        validate:{
                email: (value) => ( (/^\S+@\S+$/.test(value)|| value==="") ? null : 'Courriel Invalide'),
                phone: (value)=> ( (/^\(\d{3}\)\s\d{3}-\d{4}/.test(value) || value==="")? null:'Telephone Invalide'),
                prenom:(value)=> ((value.length > 2) ? null: "Prenom Requis"),
                nom:(value)=> ((value.length > 2) ? null: "Nom Requis")},
        transformValues: (values) => ({
            ...values,
            phone: formatPhone(values.phone),
            ageAnonym: birthdayMode,
        }),
    });
    return (
        <form 
        onSubmit={form.onSubmit((values) => {createOneMember(values).then(form.reset())})}
         onKeyDown={(e) => {
    if (e.key === "Enter" ) {
      e.preventDefault();
    }
  }}
        >
        <Container py={35} px={50}>
            <Stack align='center'>
                <Card mb={34} w={"14rem"}  >
                    <Text align='center' size={"xl"} weight={700}>Ajouter un Membre</Text>
                </Card>
            </Stack>
            <Stack>
                <Grid >
                    <Grid.Col span={6}>
                    <TextInput label="Prénom" placeholder="" classNames={classes} {...form.getInputProps('prenom')} />
                    </Grid.Col>
                    <Grid.Col span={6}>
                    <TextInput label="Nom" placeholder="" classNames={classes} {...form.getInputProps('nom')} />
                    </Grid.Col>
                </Grid>
                <Radio.Group name="genre" {...form.getInputProps('genre')} label="Genre">
                    <Radio value="homme" label="Homme" />
                    <Radio value="femme" label="Femme" />
                    <Radio value="nonbinaire" label="Non-Binaire / Autre" />
                </Radio.Group>
                <TextInput label="Numéro IUC" {...form.getInputProps("iuc")}/>
                <TextInput label="Numéro GSI" {...form.getInputProps("gsi")}/>
                <TextInput label="Courriel" classNames={classes} {...form.getInputProps('email')} />
                <TextInput label="Adresse Civique" placeholder="" classNames={classes} {...form.getInputProps('civic')} />
                <TextInput label = "Ville" placeholder="" classNames={classes} {...form.getInputProps("city")}/>
                <TextInput label="Code Postal" placeholder="" classNames={classes} {...form.getInputProps('postal')} />
                <TextInput component={InputMask} mask="(999) 999-9999" label="Téléphone" classNames={classes} {...form.getInputProps('phone')} />
                <Select mb={"lg"}
                    style={{ marginTop: 20, zIndex: 2 }}
                    data={['Téléphone', 'Courriel', 'Poste', 'Autres']}
                    placeholder={""}
                    label="Préférence de communication"
                    {...form.getInputProps('commPref')}
                />
                <Grid>
                    <Grid.Col span={2}>
                    </Grid.Col>
                    <Grid.Col span={10}>
                {birthdayMode?                 
                    <Grid >
                        <Grid.Col span={6}>
                            <NumberInput label="Jour" placeholder="" classNames={classes} {...form.getInputProps('dayOfBirth')} />
                        </Grid.Col>
                        <Grid.Col span={6}>
                        <Select
                    data={["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]}
                    label="Mois"
                    classNames={classes}
                    {...form.getInputProps('monthOfBirth')}
                />
                    </Grid.Col>
                    </Grid> : 
                <DatePicker
                    inputFormat='DD MMMM YYYY'
                    labelFormat='DD/MMMM/YYYY'
                    locale='fr-ca'
                    label="Date de Naissance"
                    classNames={classes}
                    allowFreeInput
                    clearable={false}
                    {...form.getInputProps('dateOfBirth')}
                />
}              </Grid.Col> </Grid>
                <Group>
                <Select
                    data={["Demandeur d'asile","Réfugié protégé","Résident permanent","Citoyen","Travailleur temporaire","Étudiant étranger","Visa visiteur"]}
                    label="Catégorie d'immigration"
                    searchable
                    {...form.getInputProps("immigrationStatus")}
                />
                <DatePicker
                    inputFormat='DD MMMM YYYY'
                    labelFormat='DD/MMMM/YYYY'
                    locale='fr-ca'
                    label="Date du statut"
                    allowFreeInput
                    clearable={false}
                    {...form.getInputProps('dateOfImmigrationStatus')}
                />
                
                <DatePicker
                    inputFormat='DD MMMM YYYY'
                    labelFormat='DD/MMMM/YYYY'
                    locale='fr-ca'
                    label="Date d'arrivé au Canada"
                    allowFreeInput
                    clearable={false}
                    {...form.getInputProps('dateOfArrivalCountry')}
                />
                <DatePicker
                    inputFormat='DD MMMM YYYY'
                    labelFormat='DD/MMMM/YYYY'
                    locale='fr-ca'
                    label="Date d'arrivé MRC"
                    allowFreeInput
                    clearable={false}
                    {...form.getInputProps('dateOfArrivalRegion')}
                />
                </Group>
                <Group>
                <TextInput
                    
                    label="Pays de naissance"
                    searchable
                    nothingFound="Nothing found"
                    {...form.getInputProps("countryOfOrigins")}
                    />
                <Select
                    data={["Français","Anglais","Espagnol","Autres"]}
                    label="Langue de contact"
                    searchable
                    nothingFound="Nothing found"
                    {...form.getInputProps("principalLanguages")}
                    />
                <MultiSelect
                    data={languageAdd}
                    label="Autres langues"
                    searchable
                    creatable
                    getCreateLabel={(query) => `+ Create ${query}`}
                    onCreate={(query) => {
                    const item = { value: query, label: query };
                    setLanguage((current) => [...current, item]);
                    return item;
                    }}
                    nothingFound="Nothing found"
                    {...form.getInputProps("languages")}
                    />
                    </Group>

                <Select
                    data={["Marié","Célibataire","Divorcé","Séparé","Conjoint de fait","Veuf"]}
                    label="État civil"
                    searchable
                    {...form.getInputProps("maritalStatus")}
                />
                <Select
                    data={["Salarié Temps Plein","Salarié Temps Partiel","Travailleur autonome","Sans Emploi avec assurance emploi","Sans Emploi sans assurance emploi","Retraité","Arrêt de Travail","Autres"]}
                    label="Statut d'emploi"
                    searchable
                    {...form.getInputProps("employmentStatus")}
                />
                <Group>
                    <TextInput
                        label="Diplômes"
                        {...form.getInputProps("education.diplomas")}
                        />
                    <TextInput label = "Domaine d'Étude" placeholder="" {...form.getInputProps("education.fieldOfStudy")}/>
                </Group>
                <Group>
                    <TextInput
                        label="Référence"
                        {...form.getInputProps("reference")}
                    />
                    
                    <TextInput
                        label="Intervenant durant inscription"
                        {...form.getInputProps("worker")}
                    />
                    <DatePicker 
                    label="Date d'inscription"
                    inputFormat='DD MMMM YYYY'
                    labelFormat='DD/MMMM/YYYY'
                    locale='fr-ca'
                    allowFreeInput
                     {...form.getInputProps("dateOfRegistration")}/>

                </Group>
                <Stack>
                    <TextInput label="Conjoint" {...form.getInputProps("spouse")}/>
                    <Button onClick={()=> form.insertListItem("children",{firstName:"",lastName:"",dateOfBirth:"",school:""})} > Ajouter un Enfant</Button>
                    {
                       form.values.children.map((v,i)=> <ChildrenRow form={form} index={i} {...form.getInputProps("children."+i)}/> ) 
                    }
                </Stack>
                <Card>
                    <Card.Section my={"lg"} p={"md"} bg={"blue"}>
                    <Title ta={"center"} c={"white"}>Actions</Title>
                    </Card.Section>

 
                    <Paper>
                        <Table>
                            <thead>
                                <th>

                                </th>
                                <th>
                                    Role de l'intervenant
                                </th>
                                <th>
                                    Description de l'action
                                </th>
                            </thead>
                            <tbody>
                                    {actions.map((g,index) => <ActionRow {...g}{...form.getInputProps(`actions.${index}`,{type:"checkbox"})}/>)}
                            </tbody>
                        </Table>
                    </Paper>
                </Card>
                <Button type='submit' >Soumettre</Button>
            </Stack>
        </Container >
        {console.log(form.values)}
        </form>
    );
}
function ChildrenRow(props){
    const {form,index} = props

    return(
        <Group align='center'>
            <TextInput  {...form.getInputProps(`children.${index}.firstName`)} label="Prénom"/>
            <TextInput {...form.getInputProps(`children.${index}.lastName`)} label="Nom de famille"/>
            <DatePicker                    
                inputFormat='DD MMMM YYYY'
                    labelFormat='DD/MMMM/YYYY'

                    locale='fr-ca'
                    allowFreeInput
                    {...form.getInputProps(`children.${index}.dateOfBirth`)} label="Date de naissance" />
            <TextInput {...form.getInputProps(`children.${index}.school`)} label="Scolarité"/>
            <Button mt={"xl"} onClick={(e)=> form.removeListItem('children',index)}><IconX/></Button>
        </Group>
    )
}
function ActionRow(props){
    const {title,role,completion,description,value,onChange} = props
    return(
            <tr>
                <td >
                    <Center style={{ width: "100%", height: "100%" }} >
                        <Checkbox value={value} onChange={onChange} label={title} />
                    </Center>
                </td>
                <td >
                    <Text>{role +" "+completion}</Text>
                </td>
                <td >
                    <Text>{description}</Text>
                </td>
                
            </tr>
        )
}